// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"548fc67c","212":"439653b1","314":"3df00306","542":"c6043b4a","639":"8bc0dad2","665":"092ee143","762":"479fe2bd"}[chunkId] + ".chunk.js";
};